import SectionHead from './SectionHead';
import { leads, keywords } from '../data';

const stateTone: Record<string, string> = {
  核实中: 'bg-accent-100 text-accent-900',
  待收录: 'bg-primary-100 text-primary-800',
  已闭环: 'bg-secondary-100 text-secondary-900',
};

export default function LeadSection() {
  return (
    <section id="lead" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 md:px-6 py-10 md:py-16">
      <SectionHead
        eyebrow="线索库 · 待核实与在途投稿"
        title="还差最后几块拼图"
        desc="新投稿先进入待收录，经由与已有素材比对后再转入核实。每条线索都注明来源与当前状态。"
      />

      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
        {leads.map((l) => (
          <article
            key={l.title}
            className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 md:p-6"
          >
            <div className="flex items-center justify-between gap-2">
              <span className="inline-flex items-center gap-1.5 text-[11px] font-medium text-foreground-500">
                <i className="ri-chat-smile-3-line w-3.5 h-3.5 flex items-center justify-center" />
                {l.from}
              </span>
              <span className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${stateTone[l.state]}`}>
                {l.state}
              </span>
            </div>
            <h4 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950">{l.title}</h4>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{l.body}</p>
            <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-[11px] text-foreground-500">
              <span>线索编号更新 {l.time}</span>
              <button type="button" className="inline-flex items-center gap-1 font-medium text-primary-700 hover:text-primary-800">
                查看进度
                <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center" />
              </button>
            </div>
          </article>
        ))}
      </div>

      {/* 关注词 */}
      <div className="mt-8 rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
        <span className="inline-flex items-center gap-2 font-label text-xs font-semibold tracking-wide text-foreground-700">
          <i className="ri-price-tag-3-line w-4 h-4 flex items-center justify-center text-accent-600" />
          当前关注关键词
        </span>
        <div className="mt-3 flex flex-wrap gap-2">
          {keywords.map((k) => (
            <span
              key={k}
              className="cursor-pointer whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3 py-1 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              #{k}
            </span>
          ))}
        </div>
      </div>

      {/* 投稿 CTA 条 */}
      <div className="mt-8 flex flex-col items-start justify-between gap-5 overflow-hidden rounded-xl bg-accent-600 p-6 text-background-50 md:flex-row md:items-center md:p-8">
        <div className="max-w-xl">
          <h3 className="font-heading text-xl md:text-2xl font-bold leading-snug">手上有记录或截图？把线索递上来</h3>
          <p className="mt-2 text-sm leading-relaxed text-background-50/85">
            补齐编号即可并入对应证据链，关键改口与留痕会单独标注。投稿前请先隐去无关个人信息。
          </p>
        </div>
        <a
          href="#top"
          className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-semibold text-accent-800 transition-colors hover:bg-background-100"
        >
          <i className="ri-send-plane-line w-4 h-4 flex items-center justify-center" />
          开始投稿
        </a>
      </div>
    </section>
  );
}